import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import GHCApp from './App';
import 'bootstrap/dist/css/bootstrap.css';
import { LanguageProvider } from './i18n/LanguageContext';
//import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <LanguageProvider>
      <GHCApp />
    </LanguageProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();